import { useParams } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../components/Navbar";
import { LanguageToggle } from "../../components/LanguageToggle";
import { Title } from "../../components/Title";
import { InfoBox } from "../../components/InfoBox";
import { Page } from "../../components/Page";
import { spacing } from "@styling/sizing";
import FortnoxIntegration from "./FortnoxIntegration";
import SpirisIntegration from "./SpirisIntegration";

const ContentWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing.x3}px;
  text-align: center;
`;

const BookkeepingIntegrationView = () => {
  const { t } = useTranslation();
  const { integrationType } = useParams<{ integrationType: string }>();

  if (integrationType === "fortnox") {
    return <FortnoxIntegration />;
  }

  if (integrationType === "spiris") {
    return <SpirisIntegration />;
  }

  return (
    <Page centered navbar={<Navbar><LanguageToggle /></Navbar>}>
      <ContentWrapper>
        <Title>{t("bookkeeping.unknownTitle")}</Title>
        <InfoBox variant="error">{t("bookkeeping.unknownMessage")}</InfoBox>
      </ContentWrapper>
    </Page>
  );
};

export default BookkeepingIntegrationView;